import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import { H3 } from '@ep/components/Typography';
import Magnifier from '@ep/images/magnifier.svg';
import theme from '@ep/theme';
import useQueryParam from '@ep/utils/useQueryParams';
import algoliasearch from 'algoliasearch/lite';
import React, { KeyboardEvent, useState } from 'react';
import {
  Configure,
  connectHits,
  connectSearchBox,
  Index,
  InstantSearch,
} from 'react-instantsearch-dom';

const appId = '5E6YXQV14Y';
const apiKey = 'f295d072fc1afc152af45702851a778e';
const searchClient = algoliasearch(appId, apiKey);

export interface searchProps {
  currentRefinement: string;
  refine: (value: string) => void;
}

export interface hitProps {
  url: string;
  image: string;
  title: string;
  category: string;
}

const SearchBarSpace = styled.div`
  display: flex;
  align-items: center;
`;

const StyledMagnifier = styled(Magnifier)`
  width: 5%;
`;

const SearchBarInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: none;
  &:focus {
    outline: none;
  }
`;

const SearchResultsBox = styled.div`
  margin-left: 2rem;
`;

const StyledResults = styled.div``;

const SearchResultsLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CategoryBox = styled.div`
  padding-bottom: 1rem;
`;

const CategoryTitle = styled(H3)`
  font-size: 1.5rem;
  margin: 0.5rem 0 0.25rem;
  color: ${theme.colors.duskBlue};
`;

const SearchLink = styled(Link)`
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0.5rem 0;
  color: ${theme.colors.epLinkBlue};
  line-height: 1.2rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

const SearchResultsLink = styled(Link)`
  margin-top: 2rem;
  text-align: end;
`;

const Autocomplete = () => {
  const [searchQuery, setSearchQuery] = useState(useQueryParam('query', '')[0]);

  const SearchBox = ({ refine }: searchProps) => {
    const HandleSearchKey = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        window.open('/search/?query=' + event.currentTarget.value, '_self');
      }
    };

    return (
      <SearchBarInput
        autoFocus
        type="search"
        placeholder="Search"
        defaultValue={searchQuery || ''}
        onChange={(event) => {
          refine(event.currentTarget.value);
          setSearchQuery(event.currentTarget.value);
        }}
        onKeyDown={(event) => HandleSearchKey(event)}
      />
    );
  };
  const CustomeSearchBox = connectSearchBox(SearchBox);

  const Hits = ({ hits }: hitsProps) => {
    const groupBy = (arr, property) => {
      return arr.reduce(function (memo, x) {
        if (!memo[x[property]]) {
          memo[x[property]] = [];
        }
        memo[x[property]].push(x);
        return memo;
      }, {});
    };

    const removeItemOnce = (arr, value) => {
      var index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
      return arr;
    };

    const groupedHits = groupBy(hits, 'category');

    let unique = [...new Set(hits.map((item) => item.category))];

    //unique = removeItemOnce(unique, 'other');

    // const sendToGoogleAnalytics = (label: string) => {
    //   dataLayer.push({ event: 'Search result clicked - ' + label });
    // };

    return (
      <div>
        {unique.map((category: string, index: number) => {
          return (
            <CategoryBox>
              <CategoryTitle>
                {category === 'product'
                  ? 'Products and Services'
                  : category[0].toUpperCase() + category.substring(1)}
              </CategoryTitle>
              {groupedHits[category].map((hit: hitProps) => {
                return (
                  <SearchLink
                    to={hit.url.replace('https://www.ep.com', '')}
                    // onClick={(event) =>
                    //   sendToGoogleAnalytics(
                    //     hit.title
                    //       .replaceAll(' | Entertainment Partners', '')
                    //       .replaceAll('- Entertainment Partners', '')
                    //       .replaceAll('Search Results | ', '')
                    //       //.replaceAll(' - The Production Lot', '')
                    //       .replaceAll(' — The Production Lot', '')
                    //       .replaceAll('Production Setup Support | ', 'Onboarding Support - ')
                    //   )
                    // }
                  >
                    {hit.title
                      .replaceAll(' | Entertainment Partners', '')
                      .replaceAll('- Entertainment Partners', '')
                      .replaceAll('Search Results | ', '')
                      //.replaceAll(' - The Production Lot', '')
                      .replaceAll(' — The Production Lot', '')
                      .replaceAll('Production Setup Support | ', 'Onboarding Support - ')
                      }
                  </SearchLink>
                );
              })}
            </CategoryBox>
          );
        })}
      </div>
    );
  };

  const CustomHits = connectHits(Hits);

  return (
    <StyledResults>
      <InstantSearch searchClient={searchClient} indexName="crawler_EPDC">
        <SearchResultsLinkContainer>
          <SearchBarSpace>
            <StyledMagnifier />
            <CustomeSearchBox defaultRefinement={searchQuery} />
          </SearchBarSpace>

          <SearchResultsBox>
            <Index indexName="crawler_EPDC">
              <Configure hitsPerPage={15} />
              <CustomHits />
            </Index>
          </SearchResultsBox>
          {searchQuery && (
            <SearchResultsLink to={'/search/?query=' + String(searchQuery)}>
              {`More Search Results`}
            </SearchResultsLink>
          )}
        </SearchResultsLinkContainer>
      </InstantSearch>
    </StyledResults>
  );
};

export default Autocomplete;
